import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useBreakpoint } from '@ocean/hooks'
import { modals } from '@ocean/ui'
import { useLazySelector } from 'hooks'
import { logoutUser } from 'core/session/slices/session'
import { UserDeclaration } from 'core/userDeclaration/components'
import { namespace } from 'core/userDeclaration/localization'
import {
  confirmUserDeclaration,
  changeUserDeclarationPopupVisibility,
} from 'core/userDeclaration/slices/userDeclaration'

const { Popup } = modals

const I18_PATH = `${namespace}:userDeclaration`

const UserDeclarationContainer: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isDesktop = useBreakpoint('md')

  const {
    endUserDeclarationText = '',
    userDeclarationPopupIsShown,
    isLoading,
  } = useLazySelector(({ userDeclaration }) => ({
    userDeclarationPopupIsShown: userDeclaration.userDeclarationPopupIsShown,
    endUserDeclarationText: userDeclaration.userDeclarationData.result?.data.endUserDeclarationText,
    isLoading: userDeclaration.confirmUserDeclarationRequest.isLoading,
  }))

  const handleAcceptance = useCallback(() => {
    dispatch(confirmUserDeclaration())
  }, [dispatch])

  const handleUserDeclarationPopupClose = useCallback(() => {
    dispatch(changeUserDeclarationPopupVisibility(false))
    dispatch(logoutUser())
  }, [dispatch])

  return (
    <Popup
      isOpen={userDeclarationPopupIsShown}
      onClose={handleUserDeclarationPopupClose}
      title={t(`${I18_PATH}.privacyPolicy`)}
      width={isDesktop ? '976px' : undefined}
      isLoading={isLoading}
      dataTest='UserDeclarationPopup'
    >
      <UserDeclaration
        endUserDeclarationText={endUserDeclarationText}
        onAcceptance={handleAcceptance}
      />
    </Popup>
  )
}

export default UserDeclarationContainer
